import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

export const REQUESTOR_BLOCKED_CODE = 'REQUESTOR_BLOCKED';

export interface RequestorBlockedError {
  error: string;
  code: typeof REQUESTOR_BLOCKED_CODE;
  requestor_key: string;
  message: string;
}

export function isRequestorBlockedError(err: unknown): err is HttpErrorResponse & { error: RequestorBlockedError } {
  return err instanceof HttpErrorResponse
    && err.status === 429
    && err.error?.code === REQUESTOR_BLOCKED_CODE;
}

// Kept free of HttpClient so the HTTP interceptor can inject it without a DI cycle.
@Injectable({ providedIn: 'root' })
export class RequestorBlockStateService {
  private readonly blockedSubject = new BehaviorSubject<RequestorBlockedError | null>(null);
  readonly blocked$ = this.blockedSubject.asObservable();

  get current(): RequestorBlockedError | null {
    return this.blockedSubject.value;
  }

  get isBlocked(): boolean {
    return this.blockedSubject.value !== null;
  }

  markBlocked(details: RequestorBlockedError): void {
    this.blockedSubject.next(details);
  }
}
